export const COL_GAP = "0.15rem";

export interface ColDef {
  key: string;
  label: string;
  flex: number;
}

export const PINTAG_COLUMNS: ColDef[] = [
  { key: "color",         label: "",               flex: 0.7  },
  { key: "pintag",        label: "Pintag",          flex: 1.4  },
  { key: "invoice",       label: "Invoice",         flex: 1.6  },
  { key: "customer",      label: "Customer",        flex: 1.4  },
  { key: "dateIn",        label: "Date In",         flex: 1.6  },
  { key: "pickupCashier", label: "Pickup Cashier",  flex: 1.8  },
  { key: "dropCashier",   label: "Drop Cashier",    flex: 1.8  },
  { key: "dueDate",       label: "Due Date",        flex: 1.6  },
  { key: "pieces",        label: "Pieces",          flex: 1.0  },
  { key: "rack",          label: "Rack",            flex: 1.0  },
  { key: "pickupDate",    label: "Pickup Date",     flex: 1.6  },
  { key: "description",   label: "Description",     flex: 3.0  },
  { key: "action",        label: "",               flex: 0.7  },
];
